import { AppMessage } from "../../models/app-message.model";

export interface MessageVisibilityContext {
  isPaidPlatform: boolean;
  isExternalPatient: boolean;
}

function isPaidMessage(message: AppMessage): boolean {
  return message.orderedServiceId !== null && message.orderedServiceId !== undefined;
}

export function isMessageVisibleForContext(
  message: AppMessage,
  context: MessageVisibilityContext,
): boolean {
  const paidMessage = isPaidMessage(message);

  if (context.isPaidPlatform) {
    return paidMessage;
  }

  if (context.isExternalPatient) {
    return !paidMessage && !!message.crossCommunicationStatus;
  }

  return !paidMessage;
}

export function filterMessagesForContext(
  messages: AppMessage[],
  context: MessageVisibilityContext,
): AppMessage[] {
  return (messages ?? []).filter((message) =>
    isMessageVisibleForContext(message, context),
  );
}
